<script setup lang="ts">
import WrongLogin from '@/components/login/errorAlert/WrongLogin.vue';
import ForgetPassword from '@/components/login/ForgetPassword.vue';
import LoginForm from '@/components/login/LoginForm.vue';
import SignupForm from '@/components/login/SignupForm.vue';
import SMSVerification from '@/components/login/SMSVerification.vue';
import { RouteEnum } from '@/constants/enums/RouteEnum';
import type { SignupData } from '@/models/interface/register';

const route = useRoute();
const router = useRouter();
const user = useUserStore();
const { state: KvState, fetchAll } = useKv();
const { appleVerifyHandler, lineVerifyHandler } = useThirdPartVerify();

const showForm = shallowRef<{ [key: string]: Component }>({
  LoginForm,
  SignupForm,
  ForgetPassword,
  SMSVerification,
});
const formChoose = ref('');
const showPopup = ref(false);
const showAlert = shallowRef<{ [key: string]: Component }>({
  WrongLogin
});
const rememberAccountAndPassword = ref(false);
const information = ref<SignupData>({
  fullName: '',
  email: '',
  phone: '',
  sex: '-1',
  verificationCode: '',
  mechType: useIsMobile() ? 'Mobile' : 'PC'
});
const isMobile = ref(window.innerWidth <= 768);

const isFromAd = computed(() => {
  return sessionStorage.getItem('isFromAd') === 'true';
});
const adImagePcUrl = computed(() => {
  return sessionStorage.getItem('adImagePcUrl') ? sessionStorage.getItem('adImagePcUrl') : '';
});
const adImageMobileUrl = computed(() => {
  return sessionStorage.getItem('adImageSrcPhoneUrl')
    ? sessionStorage.getItem('adImageSrcPhoneUrl')
    : '';
});

const getMemberDataAndLogin = async (token: string) => {
  user.token = token;
  user.isLogin = true;
  user.isFirstLogin = true;

  router.push({ name: RouteEnum.Index });
};
const handleUpdateSize = () => {
  isMobile.value = window.innerWidth <= 768;
};

onMounted(async () => {
  const thirdPartySigUp = sessionStorage.getItem('thirdPartySigUp');

  if (thirdPartySigUp) {
    sessionStorage.removeItem('thirdPartySigUp');
    if (thirdPartySigUp === 'Apple') {
      const { id_token } = route.query;

      if (!Array.isArray(id_token) && id_token) appleVerifyHandler(id_token);
    }
    if (thirdPartySigUp === 'Line') {
      const { code } = route.query;
      if (!Array.isArray(code) && code) lineVerifyHandler(code);
    }
  }
  fetchAll();
  window.addEventListener('resize', handleUpdateSize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleUpdateSize);
});
</script>

<template>
  <div class="landing-page">
    <LoginHeader v-model:formChoose="formChoose" />

    <div class="main-content">
      <LoginBackground v-model:formChoose="formChoose" :kv-img-error="KvState.error">
        <!-- <img
          v-if="!isFromAd || !adImagePcUrl || !adImageMobileUrl"
          :src="isMobile ? KvState.data?.imageMobile : KvState.data?.imageDesktop"
          :alt="isMobile ? KvState.data?.imageMobile : KvState.data?.imageDesktop"
          class="w-full h-full"
        /> -->
        <DefaultAnimate v-if="!isFromAd || !adImagePcUrl || !adImageMobileUrl" />
        <MarketingBg v-else />
      </LoginBackground>

      <component
        v-model:formChoose="formChoose"
        v-model:showPopup="showPopup"
        v-model:showAlert="showAlert"
        v-model:rememberAccountAndPassword="rememberAccountAndPassword"
        v-model:information="information"
        @getMemberDataAndLogin="getMemberDataAndLogin"
        :is="showForm[formChoose]"
      />

      <PopupOverlay v-model:showPopup="showPopup" :zIndex="9999">
        <component v-model:showPopup="showPopup" v-model:formChoose="formChoose" :is="showAlert" />
      </PopupOverlay>
    </div>

    <LoginFooter />
  </div>
</template>

<style scoped lang="scss">
.landing-page {
  max-width: 1920px;
  margin: 0 auto;
}
.main-content {
  position: relative;
  width: 100%;
}
</style>
